export default "__VITE_ASSET__fb198061__$_?component__"